export const SmsTemplateTypes = {
  SMS_TEMPLATE_SHOW: "SMS_TEMPLATE_SHOW",
  SMS_TEMPLATE_ADD: "SMS_TEMPLATE_ADD",
  SMS_TEMPLATE_DELETE: "SMS_TEMPLATE_DELETE",
  SMS_TEMPLATE_UPDATE: "SMS_TEMPLATE_UPDATE",
}